module.exports = __webpack_public_path__ + "media/images/creators_circle/2023/ticket-bullet-23052a555cecb39e9ab018f783a99838.svg";